import React, { Fragment, useEffect, useState } from 'react'
import ProvidersThumb from './ProvidersThumb'
import PropTypes from 'prop-types'
import { PROVIDERS_THUMBS } from '../../configs/categories'
import GameService from '../../services/GameService'

const ProvidersThumbs = ({ activeCategoryName, thumbClickHandler }) => {
    const [thumbsToDisplay, setThumbsToDisplay] = useState([])
    const [liveCasinoGames, setLiveCasinoGames] = useState([])

    const getLiveCasinoInfoByGameId = (gameIds = []) => {
        GameService.getLiveCasinoProvidersData(gameIds).then((data) => {
            if (data.length) {
                setLiveCasinoGames(data)
            }
        })
    }

    const findTableForProviderThumb = (tableId) =>
        liveCasinoGames.find((game) => game.tableId === tableId)

    const matchProvidersThumbToTable = () => {
        return PROVIDERS_THUMBS.map((thumb) => {
            const liveCasinoData = thumb.tableId
                ? findTableForProviderThumb(thumb.tableId) || {}
                : {}

            return {
                ...thumb,
                liveCasino: liveCasinoData,
                //gamesCount: providerData.total || 0,
            }
        })
    }

    const findThumbsWithGameId = () => {
        return PROVIDERS_THUMBS.filter((thumb) => thumb.tableId).map(
            (thumb) => thumb.tableId
        )
    }

    const isToShow = () => {
        return (
            ['all'].indexOf(activeCategoryName) >= 0 && liveCasinoGames.length
        )
    }

    useEffect(() => {
        const gameIds = findThumbsWithGameId()
        getLiveCasinoInfoByGameId(gameIds)
    }, [])

    useEffect(() => {
        const liveTempData = matchProvidersThumbToTable()
        setThumbsToDisplay(liveTempData)
    }, [liveCasinoGames])

    return (
        <Fragment>
            {isToShow()
                ? thumbsToDisplay.map((thumb, key) => {
                      if (
                          (Object.keys(thumb.liveCasino).length &&
                              thumb.tableId) ||
                          (!Object.keys(thumb.liveCasino).length &&
                              !thumb.tableId)
                      ) {
                          return (
                              <ProvidersThumb
                                  key={key}
                                  thumb={thumb}
                                  thumbClickHandler={thumbClickHandler}
                                  liveCasinoGames={liveCasinoGames}
                              />
                          )
                      }
                  })
                : null}
        </Fragment>
    )
}

ProvidersThumbs.propTypes = {
    activeCategoryName: PropTypes.string,
    thumbClickHandler: PropTypes.func,
}

export default ProvidersThumbs
